import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProfileService } from 'src/app/services/profile.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'fun-overview-status-position-queue',
  templateUrl: './overview-status-position-queue.component.html',
  styleUrls: ['./overview-status-position-queue.component.scss'],
})
export class OverviewStatusPositionQueueComponent implements OnInit, OnChanges {

  @Input() positionList: any[] = [];
  @Input() projectId;
  @Output() public setPositionListEvent = new EventEmitter<any>();

  loading: boolean = false;
  listOpen = true; // TODO: change to false si quiero hacer toggle
  sortedPositions: any[] = [];
  userPositionItem: any = null;
  positionsAheadCount = 0;
  moneyAhead = 0;

  constructor(private utils: UtilsService, public chdRef: ChangeDetectorRef, private profileService: ProfileService) { }

  ngOnInit() {
    if (this.utils.checkEmptyField(this.positionList)) {
      this.loading = true;
      this.profileService.getPositionQueue(this.projectId).subscribe((res: any) => {
        this.positionList = Array.isArray(res) ? res : (res?.data || res?.list || []);
        this.setPositionListEvent.emit(this.positionList);
        this.loading = false;
        this.rebuildQueueSummary();
        this.chdRef.detectChanges();
      });
    }
    this.rebuildQueueSummary();
    this.chdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.positionList) {
      this.rebuildQueueSummary();
    }
  }

  rebuildQueueSummary() {
    const list = Array.isArray(this.positionList) ? this.positionList : [];
    this.sortedPositions = list.slice().sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0));
    this.userPositionItem = this.sortedPositions.find(item => !!item?.fromUser) || null;
    if (!this.userPositionItem) {
      this.positionsAheadCount = 0;
      this.moneyAhead = 0;
      return;
    }
    this.positionsAheadCount = this.sortedPositions.filter(item => (item?.id ?? 0) < this.userPositionItem.id).length;
    this.moneyAhead = this.sortedPositions
      .filter(item => (item?.id ?? 0) < this.userPositionItem.id)
      .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0);
  }

  toggleList() {
    this.listOpen = !this.listOpen;
    this.chdRef.detectChanges();
  }
}
